export default "__VITE_ASSET__D4XOBx9d__"